import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { LANGUAGES } from "@/shared/const/locale";

const getLangFromPathname = (pathname: string): string => {
    const match = pathname.match(/^\/(ru|en|de|es|cn)(\/|$)/);
    return match ? match[1] : "en";
};

export const LanguageSwitcher: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [isCompact, setIsCompact] = React.useState(false);

    React.useEffect(() => {
        const updateSize = () => setIsCompact(window.innerWidth < 768);
        updateSize();
        window.addEventListener("resize", updateSize);
        return () => window.removeEventListener("resize", updateSize);
    }, []);

    const currentLang = getLangFromPathname(location.pathname);

    const switchLanguage = (lang: string) => {
        const segments = location.pathname.split("/").filter(Boolean);
        if (segments.length > 0 && LANGUAGES[segments[0]]) {
            segments[0] = lang;
        } else {
            segments.unshift(lang);
        }
        navigate("/" + segments.join("/") + location.search, { replace: true });
    };

    return (
        <select
            value={currentLang}
            onChange={(e) => switchLanguage(e.target.value)}
            style={{ padding: "0.4rem", fontSize: "1rem" }}
        >
            {Object.entries(LANGUAGES).map(([code, { label, flag }]) => (
                <option key={code} value={code}>
                    {isCompact ? flag : `${flag} ${label}`}
                </option>
            ))}
        </select>
    );
};
